function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.295 11.297A6.443 6.443 0 0014.666 8c-.86-2.698-3.474-4.667-6.638-4.667-1.092 0-2.121.24-3.04.657L2.332 1.333h-.999v.917l12.39 12.416h.943v-.942l-2.371-2.427zm-4.267-6.63c2.336 0 4.386 1.35 5.218 3.333a5.123 5.123 0 01-1.922 2.326L9.84 8.841c.12-.255.189-.54.189-.841a2 2 0 00-2-2c-.302 0-.586.068-.842.188L6.025 5.026a5.947 5.947 0 012.003-.36z",
  fill: "#406367"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.163 9.986L6.041 7.864c0 .018-.004.037-.006.055A.58.58 0 006.027 8a2 2 0 002 2 .579.579 0 00.082-.008.828.828 0 01.054-.006z",
  fill: "#406367"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.753 8c.833 1.982 2.939 3.333 5.275 3.333.453 0 .892-.065 1.321-.161l1.09 1.09a7.383 7.383 0 01-2.411.404c-3.165 0-5.834-1.968-6.695-4.666A6.497 6.497 0 013.269 5.09l.949.95A5.203 5.203 0 002.753 8z",
  fill: "#406367"
});

const SvgEyeHidden = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none"
}, props), _ref, _ref2, _ref3);

export default SvgEyeHidden;